import Resource from './Resource'

class Transaction extends Resource {
  get id() {
    return this.data._id
  }

  get name() {
    return this.data.name
  }

  get type() {
    return this.data.type
  }

  get status() {
    return this.data.state
  }

  get amount() {
    return this.data.amount / 100
  }

  get reward_amount() {
    return this.data.reward_amount
  }

  get timestamp() {
    return this.data.timestamp
  }

}

export default Transaction
